import React from "react";

import type { TIconProps } from "./types";

export const AdminUserSessions = React.memo((props: TIconProps) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={7} cy={5} r={3} fill="var(--fill1)" />
      <path
        d="M2 14.5C2 11.4624 4.46243 9 7.5 9H8.5C10.0766 9 11.5 9.63695 12.5355 10.6716"
        stroke="var(--fill2)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <rect x={10} y={10} width={7} height={7} rx={1.5} fill="var(--fill4)" />
      <path
        d="M13.5 12V13.5L14.5 14.5"
        stroke="var(--fill2)"
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
